import { action } from 'mobx';
import parseDate from '../shared/parseDate';
import ModelBase from './ModelBase';

export default class Action extends ModelBase {
  static className = 'Action';

  @action
  static fromJSON(id, json) {
    json.actStart = parseDate(json.actStart);
    json.actFinish = parseDate(json.actFinish);
    
    const result = super.fromJSON(id, json);

    return result;
  }
}



// WEBPACK FOOTER //
// ./src/store/Action.js